(() => {
  const buildCountryList = (ul) => {
    if (ul.dataset.built === 'true') return;

    const dataScript = ul.querySelector('script[data-country-list-data]');
    if (!dataScript) return;

    let countries;
    try {
      countries = JSON.parse(dataScript.textContent);
    } catch (error) {
      return;
    }

    const localizationForm = ul.closest('localization-form');
    const form = localizationForm ? localizationForm.querySelector('form') : null;
    const input = localizationForm ? localizationForm.querySelector('input[name="country_code"]') : null;
    const showFlags = ul.dataset.countryFlags === 'true';
    const extraLinkClass = ul.dataset.linkClass || '';
    const fragment = document.createDocumentFragment();

    countries.forEach((country) => {
      const li = document.createElement('li');
      li.className = 'disclosure__item';
      li.setAttribute('tabindex', '-1');

      const link = document.createElement('a');
      link.className =
        (extraLinkClass ? extraLinkClass + ' ' : '') +
        'disclosure__link caption-large' +
        (country.active ? ' disclosure__link--active' : '');
      link.href = '#';
      link.dataset.value = country.code;
      if (country.active) link.setAttribute('aria-current', 'true');

      if (showFlags) {
        const img = document.createElement('img');
        img.src = 'https://flagcdn.com/w80/' + country.code.toLowerCase() + '.png';
        img.width = 20;
        img.height = 15;
        img.alt = country.name;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.className = 'localization-form-v2__image';
        link.appendChild(img);
      }

      link.appendChild(document.createTextNode(country.label));
      if (country.suffix) {
        const span = document.createElement('span');
        span.className = 'localization-form__currency';
        span.textContent = country.suffix;
        link.appendChild(span);
      }

      link.addEventListener('click', (event) => {
        event.preventDefault();
        if (!form || !input) return;
        input.value = country.code;
        form.submit();
      });

      li.appendChild(link);
      fragment.appendChild(li);
    });

    dataScript.remove();
    ul.appendChild(fragment);
    ul.dataset.built = 'true';
  };

  const buildFromEvent = (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-lazy-country-list]');
    if (!button) return;

    const localizationForm = button.closest('localization-form');
    if (!localizationForm) return;

    localizationForm.querySelectorAll('ul[data-lazy-country-list]').forEach(buildCountryList);
  };

  document.addEventListener('pointerdown', buildFromEvent, true);
  document.addEventListener('click', buildFromEvent, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') buildFromEvent(event);
  }, true);
})();
